<script src="./_histogram.js"></script>
<template src="./_histogram.pug"></template>
<style src="./_histogram.scss"></style>